import { sendSystemReportFunction } from './firebaseConfig';

// Base64'e PDF dönüştürme yardımcı fonksiyonu
const convertBlobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]); // base64 içeriği al
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/**
 * CapRover Backend üzerinden e-posta gönderme
 * @param {Object} params
 * @param {string} params.recipientEmail - Alıcı e-posta adresi
 * @param {string} params.recipientName - Alıcı adı
 * @param {string} params.systemName - Sistem adı
 * @param {string} [params.reportHtml] - Opsiyonel HTML mesaj
 * @param {Blob} [params.pdfBlob] - PDF dosyası (Blob formatında)
 */
export const sendReportByEmail = async ({ recipientEmail, recipientName, systemName, reportHtml, pdfBlob }) => {
  try {
    let pdfBase64 = null;
    
    // Eğer PDF blob varsa base64'e çevir
    if (pdfBlob) {
      pdfBase64 = await convertBlobToBase64(pdfBlob);
    }

    // Varsayılan HTML içeriği (eğer gönderilmemişse)
    const finalHtml = reportHtml && typeof reportHtml === 'string' 
      ? reportHtml 
      : `<div style="font-family: Arial, sans-serif; padding: 20px;">
           <h2 style="color: #4338CA;">Merhaba ${recipientName || ''},</h2>
           <p>${systemName} için oluşturulan sistem raporu ektedir.</p>
           <hr>
           <p style="font-size: 12px; color: #666;">Energy Eye Raporlama Sistemi</p>
         </div>`;

    // CapRover veya sunucu URL'nizi buraya yazın
    // Local test için: http://localhost:3000/send-system-report
    // Prod için: https://uygulama-isimi.caprover.com/send-system-report
    const API_URL = "https://escon-mail-services.datarapor.com/send-system-report";

    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "Escon-Secure-2024-V1" // Backend ile eşleşen güvenlik anahtarı
      },
      body: JSON.stringify({
        email: recipientEmail,
        systemName: systemName,
        htmlContent: finalHtml,
        pdfBase64: pdfBase64
      }),
    });

    const result = await response.json();

    console.log("Backend API Sonucu:", result);
    
    if (result.success) {
      return { success: true, messageId: result.messageId };
    } else {
      throw new Error(result.error || "Bilinmeyen bir hata oluştu.");
    }
    
  } catch (error) {
    console.error("E-posta servisi hatası:", error);
    throw error;
  }
};
